export enum ReviewReportStatus {
    UNCHECKED = 'UNCHECKED',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED'
}
